import React, { FunctionComponent, useEffect, useState } from "react";
import GlobalStyles from "../../styles/GlobalStyles";
import { Settings } from "../../context/SettingsContext/SettingsContext";
import SettingsContext from "../../context/SettingsContext";
import { Field, Form, FormSpy } from "react-final-form";
import Select from "../../styles/Select";
import { Brand, fetchBrands, fetchModels, Model } from "../../services/mobile";
import Label from "../../styles/Label";
import styled from "styled-components";
import theme from "../../styles/theme";
import Button from "../../styles/Button";

interface ApplicationSettings {
  settings: Settings;
}

const HomeSearch: FunctionComponent<ApplicationSettings> = ({ settings }) => {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [brandRef, setBrandRef] = useState<string | null>(null);
  const [modelRef, setModelRef] = useState<string | null>(null);
  const [models, setModels] = useState<Model[]>([]);
  useEffect(() => {
    fetchBrands().then((results) => {
      if (results) {
        setBrands(
          results.filter((item) => settings.brands.indexOf(item.name) !== -1)
        );
      }
    });
  }, [settings, setBrands]);
  useEffect(() => {
    if (brandRef) {
      fetchModels(brandRef).then((response) => {
        if (response !== false) {
          setModels(response.models);
        }
      });
    }
  }, [brandRef, setModels]);
  console.log("Yo", brandRef, models);
  return (
    <Form
      onSubmit={() => {}}
      render={({ handleSubmit, values }) => (
        <form method="GET" onSubmit={handleSubmit}>
          <SelectsWrapper>
            <SettingsContext.Provider value={settings}>
              <GlobalStyles />
              <SelectWrapper>
                <Label>Merk</Label>
                <Field name="brandRef" component={Select}>
                  <option value="">--Kies een merk--</option>
                  {brands &&
                    brands.map((brand) => (
                      <option key={brand.ref} value={brand.ref}>
                        {brand.name}
                      </option>
                    ))}
                </Field>
              </SelectWrapper>
              <SelectWrapper>
                <Label>Model</Label>
                <Field name="modelRef" component={Select}>
                  <option value="">--Kies een model--</option>
                  {brandRef &&
                    models &&
                    models.map((model) => (
                      <option key={model.ref} value={model.ref}>
                        {model.name}
                      </option>
                    ))}
                </Field>
              </SelectWrapper>
            </SettingsContext.Provider>
          </SelectsWrapper>
          <ButtonWrapper>
            <Button
              color="alternate"
              onClick={() => {
                window.location.assign(
                  `/search/?brand=${encodeURIComponent(
                    `${brands.find((item) => item.ref === brandRef)?.name}`
                  )}&model=${encodeURIComponent(
                    `${models.find((item) => item.ref === modelRef)?.name}`
                  )}`
                );
              }}
            >
              Start met zoeken &gt;
            </Button>
          </ButtonWrapper>
          <FormSpy
            onChange={({ values }) => {
              setBrandRef(values.brandRef);
              setModelRef(values.modelRef);
            }}
          />
        </form>
      )}
    />
  );
};
const SelectsWrapper = styled.div`
  @media (min-width: ${theme.mediaQueries.tablet}px) {
    display: flex;
  }
`;

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  label {
    margin-bottom: ${theme.unit}px;
    color: white;
  }

  @media (min-width: ${theme.mediaQueries.tablet}px) {
    margin-right: ${theme.unit}px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export default HomeSearch;
